<template>
  <div class="routine-container">
    <div class="routine-header">
      <div class="routine-btnbar">
        <div class="routine-btnbar-group">
          <b-button class="remove-btn" @click="$emit('remove', index)">
            <IconCross alt="Eliminar rutina" />
          </b-button>
        </div>
        <div class="routine-btnbar-group">
          <!-- CardioStart button -->
          <b-button
            @click="toggleCardio('start')"
            :id="routine.id + '-cardio-start-btn'"
            :variant="routine.cardio_start ? 'secondary' : 'outline-secondary'"
          >
            <IconCardioIn />
          </b-button>
          <b-tooltip
            :target="routine.id + '-cardio-start-btn'"
            triggers="hover"
            placement="bottom"
          >{{routine.cardio_start ? "Eliminar" : "Agregar"}} cardio inicial</b-tooltip>

          <!-- Exercises button -->
          <b-button
            @click="toggleExercises"
            :id="routine.id + '-routine-exercises-btn'"
            :variant="routine.has_exercises ? 'primary' : 'outline-primary'"
          >
            <IconDumbbell />
          </b-button>
          <b-tooltip
            :target="routine.id + '-routine-exercises-btn'"
            triggers="hover"
            placement="bottom"
          >{{routine.has_exercises ? "Eliminar" : "Agregar"}} musculación</b-tooltip>

          <!-- CardioHiit button -->
          <b-button
            @click="toggleHiit"
            :id="routine.id + '-cardio-hiit-btn'"
            :variant="routine.cardio_hiit ? 'info' : 'outline-info'"
          >
            <i class="wizard-icon ti-alarm-clock" />
          </b-button>
          <b-tooltip
            :target="routine.id + '-cardio-hiit-btn'"
            triggers="hover"
            placement="bottom"
          >{{routine.cardio_hiit ? "Eliminar" : "Agregar"}} cardio HIIT</b-tooltip>

          <!-- CardioEnd button -->
          <b-button
            @click="toggleCardio('end')"
            :id="routine.id + '-cardio-end-btn'"
            :variant="routine.cardio_end ? 'secondary' : 'outline-secondary'"
          >
            <IconCardioOut />
          </b-button>
          <b-tooltip
            :target="routine.id + '-cardio-end-btn'"
            triggers="hover"
            placement="bottom"
          >{{routine.cardio_end ? "Eliminar" : "Agregar"}} cardio final</b-tooltip>
        </div>
      </div>
      <EditableCellInput v-model="routine.name" class="routine-title" />
    </div>

    <DaysCheckbox v-model="routine.days" />

    <transition name="table-transition">
      <div class="cardio-table-wrapper" v-if="routine.cardio_start">
        <CardioTable v-model="routine.cardio_start" title="Cardiovascular Inicio" />
      </div>
    </transition>

    <transition name="table-transition">
      <div class="routine-table-wrapper" v-if="routine.has_exercises">
        <RoutineTable v-model="routine.exercises" :routine="routine.id" :colorPresets="routine.colorPresets" />
      </div>
    </transition>

    <transition name="table-transition">
      <div class="cardio-table-wrapper" v-if="routine.cardio_hiit">
        <HiitTable v-model="routine.cardio_hiit" :routine="routine.id" :hiitPresets="hiitPresets" :hiitOptions="hiitOptions"/>
      </div>
    </transition>

    <transition name="table-transition">
      <div class="cardio-table-wrapper" v-if="routine.cardio_end">
        <CardioTable v-model="routine.cardio_end" title="Cardiovascular Final" />
      </div>
    </transition>
  </div>
</template>

<script>
import EditableCellInput from "./EditableCellInput";
import DaysCheckbox from "./checkbox/DaysCheckbox";
import CardioTable from "./table/CardioTable";
import RoutineTable from "./table/RoutineTable";
import HiitTable from "./table/HiitTable";
import IconCardioOut from "./icon/IconCardioOut";
import IconCardioIn from "./icon/IconCardioIn";
import IconDumbbell from "./icon/IconDumbbell";
import IconCross from "./icon/IconCross";

export default {
  name: "ProgramRoutine",
  components: {
    IconCross,
    IconDumbbell,
    IconCardioIn,
    IconCardioOut,
    RoutineTable,
    CardioTable,
    HiitTable,
    DaysCheckbox,
    EditableCellInput
  },
  model: {
    prop: "routine",
    event: "change"
  },
  props: {
    index: Number,
    routine: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hiitPresets: {
      type: Array,
      default: function() {
        return [];
      }
    },
    hiitOptions: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      savedRoutine: {},
      defaultRoutine: {
        exercises: [],
        cardio_start: {},
        cardio_hiit: null,
        cardio_end: {}
      }
    };
  },
  watch: {
    "routine.exercises"(val) {
      this.saveExercises(val);
    },
    "routine.cardio_start"(val) {
      this.saveCardioStart(val);
    },
    "routine.cardio_end"(val) {
      this.saveCardioEnd(val);
    },
    "routine.cardio_hiit"(val) {
      this.saveCardioHiit(val);
    }
  },
  mounted() {
    this.saveExercises(this.routine.exercises);
    this.saveCardioStart(this.routine.cardio_start);
    this.saveCardioEnd(this.routine.cardio_end);
    this.saveCardioHiit(this.routine.cardio_hiit)
    this.$forceUpdate();
  },
  methods: {
    toggleCardio: function(cardioName) {
      const name = "cardio_" + cardioName;
      if (this.routine[name]) {
        this.routine[name] = null;
      } else {
        this.routine[name] =
          this.savedRoutine[name] ||
          Object.assign({}, this.defaultRoutine[name]);
      }
    },
    toggleExercises: function() {
      if (this.routine.has_exercises) {
        this.routine.has_exercises = false;
        this.routine.exercises = [];
      } else {
        this.routine.has_exercises = true;
        this.routine.exercises =
          this.savedRoutine.exercises || this.defaultRoutine.exercises.slice();
      }
    },
    toggleHiit: function() {
      if (this.routine.cardio_hiit) {
        this.routine.cardio_hiit = null
      } else {
        this.routine.cardio_hiit = {
          sets: 4,
          circuits: []
        }
      }
    },
    saveExercises(val) {
      if (this.routine.has_exercises) {
        this.savedRoutine.exercises = val;
      }
    },
    saveCardioStart(val) {
      if (val) {
        this.savedRoutine.cardio_start = val;
      }
    },
    saveCardioEnd(val) {
      if (val) {
        this.savedRoutine.cardio_end = val;
      }
    },
    saveCardioHiit(val) {
      if (val) {
        this.savedRoutine.cardio_hiit = val;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.routine-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gray-400;
  border-radius: 10px;
  padding: 0 map_get($spacers, 4) map_get($spacers, 4);
  margin: $spacer * 4 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.routine-header {
  position: sticky;
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;
  top: 0;
  background-color: white;
  z-index: $zindex-sticky;
  padding: map_get($spacers, 3) 0;
  border-bottom: 1px solid $gray-300;
}

.routine-title {
  margin-right: 15rem;
  margin-left: 3rem;
  font-size: $h3-font-size;
  font-weight: bold;
  color: $body-color;
  width: 100%;
  height: auto;
  text-align: left;
}

.routine-btnbar {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: -1;

  & .routine-btnbar-group button {
    margin: 0 map_get($spacers, 1);
    width: 2.5rem;
    height: 2.5rem;
    padding: 0.5rem;
    line-height: 1;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    & svg {
      width: 100%;
      height: 100%;
      fill: currentColor;
    }
  }

  & .remove-btn {
    background-color: transparent;
    border: none;
    color: $gray-600;
    opacity: 0.2;

    .routine-header:hover & {
      opacity: 0.5;
    }

    &:hover {
      opacity: 1 !important;
    }
  }
}

.cardio-table-wrapper,
.routine-table-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: $spacer;
  margin-bottom: $spacer;
  text-align: center;
}

.cardio-table-wrapper {
  margin-left: auto;
  margin-right: auto;
}

.routine-table-wrapper {
  width: 100%;
}

.table-transition-enter-active,
.table-transition-leave-active {
  transition-property: margin, opacity, max-height;
  transition-duration: 0.25s;
}

.table-transition-enter,
.table-transition-leave-to {
  margin-top: 0;
  margin-bottom: 0;
  opacity: 0;
  max-height: 0;
}

.table-transition-leave,
.table-transition-enter-to {
  opacity: 1;
  max-height: 10rem;
}
</style>